export default "__VITE_ASSET__DwJ4vZi4__"